import { render, staticRenderFns } from "./indexApp.vue?vue&type=template&id=fd746036&scoped=true&"
import script from "./indexApp.vue?vue&type=script&lang=js&"
export * from "./indexApp.vue?vue&type=script&lang=js&"
import style0 from "./indexApp.vue?vue&type=style&index=0&id=fd746036&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd746036",
  null
  
)

export default component.exports